import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import clsx from "clsx";

const MAX_WIDTH_CLASSES = {
  sm: "max-w-sm",
  md: "max-w-md",
  lg: "max-w-lg",
};

// Standardizes on Headless UI Dialog (the correct pattern already used in
// ConnectDialog.jsx — focus trap, escape-to-close, accessible backdrop) in place
// of the hand-rolled `fixed inset-0 bg-black/40` overlay divs found elsewhere.
// Matches the simpler centered-panel shape (no title icon, no enter/leave
// transition) used by InventoryDetail.jsx's Manufacture modal.
//
// `maxWidth` is a named variant (not a raw className override) because two
// same-category Tailwind width utilities (e.g. a caller's `max-w-md` passed via
// `className` alongside this component's own `max-w-sm`) don't reliably resolve
// by source order — whichever rule lands later in the compiled stylesheet wins,
// not whichever class appears later in the className string. Kept in sync with
// infra/admin/app/src/components/ui/Modal.jsx — same primitive, ported verbatim.
export default function Modal({ open, onClose, title, maxWidth = "sm", children, className }) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <DialogBackdrop className="fixed inset-0 bg-black/40 dark:bg-black/60" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className={clsx("w-full rounded-card bg-white dark:bg-gray-800 shadow-xl p-6", MAX_WIDTH_CLASSES[maxWidth] ?? MAX_WIDTH_CLASSES.sm, className)}>
          {title && (
            <DialogTitle as="h2" className="text-base font-semibold text-gray-900 dark:text-gray-100 mb-4">
              {title}
            </DialogTitle>
          )}
          {children}
        </DialogPanel>
      </div>
    </Dialog>
  );
}
